/**
 * Size quick add for Boost product cards: the card button opens a row of sizes,
 * and choosing one submits the card's product form with that variant.
 */
class BoostSizeAdd extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-size-add-toggle]');
    this.panel = this.querySelector('[data-size-add-panel]');
    this.variantInput = this.querySelector('input[name="id"]');
    if (!this.toggle || !this.panel || !this.variantInput) return;

    this.handleClick = (event) => this.onClick(event);
    this.handleKeydown = (event) => this.onKeydown(event);
    this.handleOutsideClick = (event) => {
      if (!this.contains(event.target)) this.setOpen(false);
    };

    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
    this.addEventListener('submit', () => this.setOpen(false));
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  onClick(event) {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('[data-size-add-toggle]')) {
      this.setOpen(this.panel.hidden);
      return;
    }

    const size = event.target.closest('[data-variant-id]');
    if (size) this.variantInput.value = size.dataset.variantId;
  }

  onKeydown(event) {
    if (event.key !== 'Escape' || this.panel.hidden) return;

    this.setOpen(false);
    this.toggle.focus();
  }

  setOpen(open) {
    this.panel.hidden = !open;
    this.toggle.setAttribute('aria-expanded', String(open));

    if (open) {
      document.addEventListener('click', this.handleOutsideClick);
    } else {
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }
}

if (!customElements.get('boost-size-add')) {
  customElements.define('boost-size-add', BoostSizeAdd);
}
